<template>
  <article id="week">
    <!-- BIG SCREEN -->
    <table v-if="!isMediumScreen" id="week-table">
      <tr>
        <th
          class="head"
          :class="{ selectable }"
          v-for="(day, index) in days"
          :key="index"
          @click="onDateClick(index)"
        >
          {{ day | fullDate }}
        </th>
      </tr>
      <tr>
        <td
          class="cell"
          :class="{ isToday: isToday(day) }"
          v-for="(day, index) in days"
          :key="index"
        >
          <DayMeal
            ref="dayMealLunch"
            :day="day"
            mealTime="lunch"
            :updatable="updatable"
            :selectable="selectable"
            :selectedMealsId="selectedMealsId"
          />
        </td>
      </tr>
      <tr>
        <td
          class="cell"
          :class="{ isToday: isToday(day) }"
          v-for="(day, index) in days"
          :key="index"
        >
          <DayMeal
            ref="dayMealDinner"
            :day="day"
            mealTime="dinner"
            :updatable="updatable"
            :selectable="selectable"
            :selectedMealsId="selectedMealsId"
          />
        </td>
      </tr>
    </table>

    <!-- PHONE SCREEN -->
    <table v-else id="week-table" class="phone">
      <tr v-for="(day, index) in days" :key="index">
        <td class="head" @click="onDateClick(index)">
          <p>{{ day | fullDate }}</p>
        </td>
        <td class="cell" :class="{ isToday: isToday(day) }">
          <DayMeal
            ref="dayMealLunch"
            :day="day"
            mealTime="lunch"
            :updatable="updatable"
            :selectable="selectable"
            :selectedMealsId="selectedMealsId"
          />
        </td>
        <td class="cell" :class="{ isToday: isToday(day) }">
          <DayMeal
            ref="dayMealDinner"
            :day="day"
            mealTime="dinner"
            :updatable="updatable"
            :selectable="selectable"
            :selectedMealsId="selectedMealsId"
          />
        </td>
      </tr>
    </table>
  </article>
</template>

<script>
import moment from 'moment';
import DayMeal from './DayMeal.vue';

export default {
  components: {
    DayMeal,
  },
  props: {
    updatable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedMealsId: {
      type: Array,
      default: () => [],
    },
    days: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      weeks: [],
      selected: [],
      swipeIndex: 1,
    };
  },
  methods: {
    /**
     * Permet de colorer la journée du jour
     */
    isToday(day) {
      return day.isSame(moment(), 'day');
    },

    /**
     * Retourne tous les plannedMeals sélectionnés
     */
    getSelectedPlannedMeals() {
      let selected = [];
      this.$refs.dayMealLunch.forEach((dayMeal) => {
        selected = selected.concat(dayMeal.getSelectedPlannedMeals());
      });
      this.$refs.dayMealDinner.forEach((dayMeal) => {
        selected = selected.concat(dayMeal.getSelectedPlannedMeals());
      });
      return selected;
    },

    /**
     * Quand on clique sur une date
     */
    onDateClick(index) {
      if (!this.selectable) {
        return;
      }
      this.$refs.dayMealLunch[index].selectAllMeals();
      this.$refs.dayMealDinner[index].selectAllMeals();
    },
  },
};
</script>

<style lang="scss" scoped src="./Week.scss"></style>
